module.exports = __webpack_public_path__ + "img/case1_1.e9b612d5.png";